// extracted by mini-css-extract-plugin
export default {"origin_wrap":"index_origin_wrap_YFHAw","no_data":"index_no_data_25y0p"};